import { locale } from '../../../locales/locale'

export interface ChatConfigStore {
  openable: boolean
  singleConversation: boolean
  warning: string
}

export interface Attributes {
  is_admin: boolean
  is_user: boolean
  is_employee: boolean
  is_through_accountant: boolean
  is_accountant: boolean
  is_support: boolean
  email_hash: string
}

export interface Info {
  id: number
  name: string
  email: string
}

export interface PrivacyConsents {
  info: string | null
  offers: string | null
  surveys: string | null
  third: string | null
}

export interface Service {
  active: boolean
  expire: string
  signup: string
  plan: number
  plan_name: string
}

export interface Services {
  registration_service: number
  fic: Service
  dic: Service
}

export interface ChatInfoStore {
  attributes: Attributes
  company: Info
  person: Info
  privacy: PrivacyConsents | null
  services: Services
}


export interface ChatStore {
  config: ChatConfigStore
  info: ChatInfoStore | null
  visible: boolean
  hideInternal: boolean
}

export const chatInitialState: ChatStore = {
  hideInternal: false,
  visible: false,
  info: null,
  config: {
    openable: false,
    singleConversation: false,
    warning: locale('Il tempo medio di risposta è di 30 minuti'),
  },
}
